<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <modal-change-work-shift-cyclic :wsSelected="wsSelected"
                                    :reloadPageCyclic.sync="reloadPageCyclic"></modal-change-work-shift-cyclic>

    <section>
      <page-header :headerName="'Turnos Cíclico da Empresa'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/detalhes-da-empresa/' + this.$route.params.idCompany + '/' + this.$route.params.context"
                   :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- No Result -->
            <div v-if="!loading && !dataWorkShift.length && !failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum turno cadastrado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataWorkShift.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="portlet light">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de turnos cíclicos ({{ dataWorkShift.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> ID</th>
                        <th> CÓDIGO</th>
                        <th> NOME</th>
                        <th> ciclicFreeDays</th>
                        <th> ciclicWorkingDays</th>
                        <th> currentTimeZone</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataWorkShift">
                        <th>{{ c.id }}</th>
                        <td>{{ c.code }}</td>
                        <td>{{ c.name }}</td>
                        <td>{{ c.ciclicFreeDays }}</td>
                        <td>{{ c.ciclicWorkingDays }}</td>
                        <td>{{ c.currentTimeZone }}</td>
                        <td>
                          <a v-on:click="openModalEditWs(c)" title="Editar">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </a>
                          <a v-bind:href="'/lista-de-dias-do-turno/' + companyId + '/' + c.id + '/1' + '/' + context"
                             title="Visualizar dias">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import modalChangeWorkShiftCyclic from "../../modals/modalChangeWorkShiftCyclic.vue";
import swal from 'sweetalert';

import {
  WORK_SHIFT_BY_TYPE,
  USERS_ENABLE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "list-all-work-shift-cyclic",
  components: {
    topMenu,
    pageHeader,
    modalChangeWorkShiftCyclic,
    fullLoading
  },
  data() {
    return {
      companyId: this.$route.params.idCompany,
      context: this.$route.params.context,
      reloadPageCyclic: 0,
      checkAll: false,
      checked: false,
      loading: false,
      failRequest: false,
      dataWorkShift: null,
      qtdWorkShift: 30,
      wsSelected: null
    }
  },
  methods: {
    getWorkShiftByCompany() {
      this.loading = true;

      let url = WORK_SHIFT_BY_TYPE + "?companyId=" + this.companyId;
      url += "&type=2";

      REQUEST_SERVICE.requestContext('GET', url, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT WORK_SHIFT_BY_TYPE:", response.data);

        this.dataWorkShift = response.data;
        this.loading = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    openModalEditWs(ws) {
      this.wsSelected = ws;
      this.wsSelected.context = this.context;
      $("#modalChangeWsCyclic").modal();
    }
  },
  beforeMount() {
    this.getWorkShiftByCompany();
  },
  watch: {
    reloadPageCyclic: function (val) {
      this.getWorkShiftByCompany();
    }
  }
}
</script>

<style lang="scss">
.search-employers {
  position: absolute;
  right: 0;
  margin-top: 10px;

  .user-disabled {
    position: absolute;
    top: -55px;
    cursor: pointer;
    color: #837d7d;
    border-bottom: 1px solid #bdb3b3;

    &:hover {
      text-decoration: none;
    }
  }

  label {
    display: block;
    font-weight: 600;
    letter-spacing: 1px;
  }

  input {
    display: inline-block;
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 50%;
  }

  button {
    background: #3598dc;
    color: #ffffff;
    text-decoration: none;
    margin-right: 30px;
    border-radius: 4px !important;
    border: none;
    font-weight: 600;
    display: inline-block;
    height: 33px;
    line-height: 34px;
    margin-left: 0;
    padding: 0 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/listAllWorkShiftCyclic.vue